(function () {
  'use strict';

  function initialise() {
    var root = document.querySelector('[data-best-results]');
    var selector = document.querySelector('[data-best-selector]');
    if (!root || !selector || root.dataset.bestReady) return;
    var form = root.querySelector('[data-aquatic-filters]');
    var catalogue = root.querySelector('[data-best-catalogue]');
    var count = root.querySelector('[data-best-count]');
    var active = root.querySelector('[data-best-active]');
    var empty = root.querySelector('[data-best-empty]');
    var pagination = root.querySelector('[data-best-pagination]');
    if (!form || !catalogue || !count || !active || !empty || !pagination) return;
    var pageSize = Number(root.dataset.bestPageSize);
    var total = Number(root.dataset.bestTotal);
    var currentServerPage = Number(catalogue.dataset.bestPage) || 1;
    var serverPages = Math.max(1, Number(catalogue.dataset.bestPages) || 1);
    var pageParam = catalogue.dataset.bestPageParam || 'page';
    if (!Number.isInteger(pageSize) || pageSize < 1 || !Number.isInteger(total) || total < 0 ||
        serverPages !== Math.max(1, Math.ceil(total / pageSize)) || currentServerPage > serverPages) return;

    root.dataset.bestReady = 'true';
    var buttons = Array.from(selector.querySelectorAll('[data-best-group]'));
    var groups = new Map(buttons.map(function (button) { return [button.dataset.bestGroup, button.dataset.bestLabel]; }));
    var sources = new Map(buttons.map(function (button) {
      return [button.dataset.bestGroup, (button.dataset.bestSources || '').split(' ').filter(Boolean)];
    }));
    var grid = root.querySelector('.mas-aquatic__grid');
    var nativePagination = root.querySelector('.mas-aquatic__pagination:not([data-best-pagination])');
    var nativeEmpty = root.querySelector('.mas-aquatic__empty:not([data-best-empty])');
    var initialCards = Array.from(root.querySelectorAll('[data-best-product]'));
    var cards = new Map();
    var cardPages = new Map();
    var pageRequests = new Map();
    var index = null;
    var indexRequest = null;
    var navigation = 0;
    var group = '';
    var page = currentServerPage;
    var matchingTotal = total;
    var sortInput = form.querySelector('[name="sort_by"]');
    var serverSortOption = sortInput && Array.from(sortInput.options).find(function (option) { return option.defaultSelected; });
    var sortBy = serverSortOption ? serverSortOption.value : (sortInput ? sortInput.value : '');
    var requestBase = new URL(window.location.href);
    var indexView = root.dataset.bestIndexView;
    var groupInput = document.createElement('input');
    groupInput.type = 'hidden';
    groupInput.name = 'group';
    form.appendChild(groupInput);
    var notice = document.createElement('div');
    notice.hidden = true;
    notice.setAttribute('aria-live', 'polite');
    count.after(notice);
    var retryTarget = null;

    function baseUrl() {
      var url = new URL(requestBase);
      url.hash = '';
      ['page', pageParam, 'group', 'best_page', 'section_id', 'sections', 'view'].forEach(function (key) {
        url.searchParams.delete(key);
      });
      return url;
    }

    function locationFor(nextGroup, nextPage) {
      var url = baseUrl();
      if (nextGroup) url.searchParams.set('group', nextGroup);
      if (nextPage > 1) url.searchParams.set(nextGroup ? 'best_page' : pageParam, String(nextPage));
      return url;
    }

    var initialCommittedUrl = locationFor('', currentServerPage);
    if (requestBase.hash === '#' + root.id) initialCommittedUrl.hash = requestBase.hash;
    var committedUrl = initialCommittedUrl.toString();

    function requestedLocation() {
      var params = new URL(window.location.href).searchParams;
      var requestedGroup = groups.has(params.get('group')) ? params.get('group') : '';
      var requestedPage = params.get('best_page') || (requestedGroup ? '1' : params.get(pageParam)) || '1';
      return { group: requestedGroup, page: Math.max(1, Math.floor(Number(requestedPage) || 1)) };
    }

    function validId(id) { return typeof id === 'string' && /^[1-9][0-9]*$/.test(id); }

    function membershipsFor(card) {
      return (card.dataset.bestGroups || '').split(' ').filter(Boolean);
    }

    var initialEntries = initialCards.map(function (card, offset) {
      var entry = { id: card.dataset.bestProduct, position: (currentServerPage - 1) * pageSize + offset, groups: membershipsFor(card) };
      cards.set(entry.id, { node: card, position: entry.position });
      return entry;
    });
    cardPages.set(currentServerPage, initialEntries);

    function showLoading() {
      root.setAttribute('aria-busy', 'true');
      notice.replaceChildren();
      notice.setAttribute('role', 'status');
      notice.textContent = root.dataset.bestLoadingLabel || '';
      notice.hidden = !notice.textContent;
    }

    function clearNotice() {
      root.removeAttribute('aria-busy');
      notice.hidden = true;
      notice.replaceChildren();
      retryTarget = null;
    }

    function showError(target) {
      root.removeAttribute('aria-busy');
      groupInput.value = group;
      groupInput.disabled = !group;
      notice.replaceChildren();
      notice.setAttribute('role', 'alert');
      var message = document.createElement('p');
      message.textContent = root.dataset.bestErrorLabel || '';
      var retry = document.createElement('button');
      retry.type = 'button';
      retry.className = 'mas-aquatic__apply';
      retry.textContent = root.dataset.bestRetryLabel || '';
      retry.addEventListener('click', function () {
        if (retryTarget) choose(retryTarget.group, retryTarget.page, retryTarget.scroll, retryTarget.history);
      });
      var fallback = document.createElement('a');
      fallback.href = baseUrl().toString();
      fallback.textContent = root.dataset.bestFallbackLabel || '';
      notice.append(message, retry, document.createTextNode(' '), fallback);
      notice.hidden = false;
      retryTarget = target;
      // A popstate/deep link has already changed the address. Restore the URL
      // describing the still-displayed cards, and keep the failed intent for retry.
      window.history.replaceState(null, '', committedUrl);
    }

    function validateIndexPage(data, expectedPage, first) {
      if (!data || data.version !== 1 || data.collectionHandle !== 'best-selling' || data.sortBy !== sortBy ||
          data.total !== total || data.page !== expectedPage || !Number.isInteger(data.pageSize) || data.pageSize < 1 || data.pageSize > 250 ||
          !Number.isInteger(data.pages) || data.pages < 0 || data.pages !== Math.ceil(total / data.pageSize) ||
          typeof data.pageParam !== 'string' || !/^page(?:_[a-zA-Z0-9]+)?$/.test(data.pageParam) || !Array.isArray(data.products)) {
        throw new Error('Unexpected catalogue index');
      }
      if (first && (data.pageSize !== first.pageSize || data.pages !== first.pages || data.pageParam !== first.pageParam)) {
        throw new Error('Catalogue index changed');
      }
      var expectedLength = Math.max(0, Math.min(data.pageSize, total - (expectedPage - 1) * data.pageSize));
      if (data.products.length !== expectedLength) throw new Error('Incomplete catalogue index page');
      data.products.forEach(function (product) {
        if (!product || !validId(product.id) || !Array.isArray(product.groups) || product.groups.some(function (handle) {
          return typeof handle !== 'string' || !handle || /\s/.test(handle);
        }) || new Set(product.groups).size !== product.groups.length) throw new Error('Invalid catalogue membership');
      });
      return data;
    }

    async function fetchIndexPage(number, first) {
      if (!indexView) throw new Error('Catalogue index unavailable');
      var url = baseUrl();
      url.searchParams.set('view', indexView);
      url.searchParams.set(first ? first.pageParam : 'page', String(number));
      var response = await fetch(url.toString(), { credentials: 'same-origin' });
      if (!response.ok) throw new Error('Catalogue index unavailable');
      var doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      var payload = doc.querySelector('script[type="application/json"][data-best-index]');
      if (!payload) throw new Error('Catalogue index payload unavailable');
      return validateIndexPage(JSON.parse(payload.textContent), number, first);
    }

    function ensureIndex() {
      if (index) return Promise.resolve(index);
      if (indexRequest) return indexRequest;
      indexRequest = (async function () {
        var first = await fetchIndexPage(1);
        var products = first.products.slice();
        for (var number = 2; number <= first.pages; number++) {
          var next = await fetchIndexPage(number, first);
          products.push.apply(products, next.products);
        }
        if (products.length !== total || new Set(products.map(function (product) { return product.id; })).size !== total) {
          throw new Error('Incomplete or duplicate catalogue index');
        }
        cardPages.forEach(function (entries) {
          entries.forEach(function (entry) {
            var expected = products[entry.position];
            if (!expected || expected.id !== entry.id || expected.groups.slice().sort().join(' ') !== entry.groups.slice().sort().join(' ')) {
              throw new Error('Catalogue index no longer matches cards');
            }
          });
        });
        index = products;
        return index;
      }()).catch(function (error) { indexRequest = null; throw error; });
      return indexRequest;
    }

    function ensureCardPage(number) {
      if (cardPages.has(number)) return Promise.resolve(cardPages.get(number));
      if (pageRequests.has(number)) return pageRequests.get(number);
      var promise = (async function () {
        var url = baseUrl();
        url.searchParams.set(pageParam, String(number));
        url.searchParams.set('section_id', root.dataset.bestSection);
        var response = await fetch(url.toString(), { credentials: 'same-origin' });
        if (!response.ok) throw new Error('Catalogue page unavailable');
        var doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        var results = doc.querySelector('[data-best-results]');
        var metadata = results && results.querySelector('[data-best-catalogue]');
        var responseSort = results && results.querySelector('[name="sort_by"]');
        if (!results || !metadata || results.dataset.bestSection !== root.dataset.bestSection ||
            Number(results.dataset.bestTotal) !== total || Number(results.dataset.bestPageSize) !== pageSize ||
            Number(metadata.dataset.bestPage) !== number || Math.max(1, Number(metadata.dataset.bestPages)) !== serverPages ||
            (metadata.dataset.bestPageParam || 'page') !== pageParam || !responseSort || responseSort.value !== sortBy) throw new Error('Unexpected catalogue page');
        var nodes = Array.from(results.querySelectorAll('[data-best-product]'));
        if (nodes.length !== Math.min(pageSize, total - (number - 1) * pageSize)) throw new Error('Incomplete catalogue page');
        var entries = nodes.map(function (node, offset) {
          var id = node.dataset.bestProduct;
          var position = (number - 1) * pageSize + offset;
          var memberships = membershipsFor(node);
          if (!validId(id)) throw new Error('Invalid product id');
          if (index && (index[position].id !== id || index[position].groups.slice().sort().join(' ') !== memberships.slice().sort().join(' '))) {
            throw new Error('Catalogue page no longer matches index');
          }
          cardPages.forEach(function (knownEntries) {
            knownEntries.forEach(function (known) {
              if (known.id === id && known.position !== position || known.id !== id && known.position === position) throw new Error('Catalogue order changed');
            });
          });
          return { id: id, position: position, groups: memberships, html: node.outerHTML };
        });
        if (new Set(entries.map(function (entry) { return entry.id; })).size !== entries.length) throw new Error('Duplicate catalogue product');
        cardPages.set(number, entries);
        return entries;
      }()).catch(function (error) { pageRequests.delete(number); throw error; });
      pageRequests.set(number, promise);
      return promise;
    }

    function connectCards(entries) {
      var added = false;
      if (entries.length && !grid) throw new Error('Catalogue grid unavailable');
      entries.forEach(function (entry) {
        if (cards.has(entry.id)) return;
        var template = document.createElement('template');
        template.innerHTML = entry.html;
        var node = template.content.firstElementChild;
        if (!node || node.dataset.bestProduct !== entry.id) throw new Error('Invalid cached product');
        node.hidden = true;
        var next = null;
        cards.forEach(function (known) {
          if (known.position > entry.position && (!next || known.position < next.position)) next = known;
        });
        // Only a new, never-connected subtree is inserted. Existing native
        // product/wishlist/compare elements retain identity and lifecycle state.
        grid.insertBefore(node, next ? next.node : null);
        cards.set(entry.id, { node: node, position: entry.position });
        added = true;
      });
      if (added) grid.dispatchEvent(new CustomEvent('shopify:section:load', { bubbles: true }));
    }

    function appendPageLink(label, target, accessibleLabel) {
      var link = document.createElement('a');
      var url = locationFor(group, target);
      url.hash = root.id;
      link.href = url.toString();
      link.textContent = label;
      link.dataset.bestPageLink = String(target);
      link.setAttribute('aria-label', accessibleLabel);
      pagination.appendChild(link);
    }

    function render(ids) {
      var visible = new Set(ids);
      cards.forEach(function (card, id) { card.node.hidden = !visible.has(id); });
      buttons.forEach(function (button) {
        var selected = button.dataset.bestGroup === group;
        button.setAttribute('aria-pressed', String(selected));
        button.classList.toggle('is-current', selected);
      });
      var pages = Math.max(1, Math.ceil(matchingTotal / pageSize));
      var start = (page - 1) * pageSize;
      count.textContent = matchingTotal + (matchingTotal === 1 ? ' product' : ' products') +
        (group ? ' · ' + groups.get(group) : '') +
        (pages > 1 ? ' · Showing ' + (start + 1) + '–' + Math.min(start + pageSize, matchingTotal) : '');
      active.hidden = !group;
      active.querySelector('button').textContent = (groups.get(group) || '') + ' ×';
      active.querySelector('button').setAttribute('aria-label', 'Remove category: ' + (groups.get(group) || 'All'));
      groupInput.value = group;
      groupInput.disabled = !group;
      empty.hidden = !!matchingTotal;
      if (grid) grid.hidden = !matchingTotal;
      if (nativeEmpty) nativeEmpty.hidden = true;
      if (nativePagination) nativePagination.hidden = true;
      root.querySelectorAll('.mas-aquatic__active-filters a').forEach(function (link) {
        var url = new URL(link.href);
        url.searchParams.delete('best_page');
        if (group && !link.classList.contains('mas-aquatic__clear')) url.searchParams.set('group', group);
        else url.searchParams.delete('group');
        link.href = url.toString();
      });
      pagination.replaceChildren();
      pagination.hidden = pages <= 1;
      if (pages > 1) {
        if (page > 1) appendPageLink('←', page - 1, 'Previous page');
        for (var number = 1; number <= pages; number++) {
          if (number !== 1 && number !== pages && Math.abs(number - page) > 1) {
            if (number === page - 2 || number === page + 2) {
              var ellipsis = document.createElement('span');
              ellipsis.textContent = '…';
              pagination.appendChild(ellipsis);
            }
            continue;
          }
          if (number === page) {
            var current = document.createElement('span');
            current.textContent = String(number);
            current.setAttribute('aria-current', 'page');
            pagination.appendChild(current);
          } else appendPageLink(String(number), number, 'Go to page ' + number);
        }
        if (page < pages) appendPageLink('→', page + 1, 'Next page');
      }
    }

    async function choose(nextGroup, nextPage, scroll, historyMode) {
      var token = ++navigation;
      var target = { group: nextGroup, page: nextPage, scroll: scroll, history: historyMode };
      groupInput.value = nextGroup;
      groupInput.disabled = !nextGroup;
      showLoading();
      try {
        var matching = nextGroup ? (await ensureIndex()).filter(function (product) {
          return sources.get(nextGroup).some(function (handle) { return product.groups.includes(handle); });
        }) : null;
        if (token !== navigation || !root.isConnected) return;
        var nextTotal = matching ? matching.length : total;
        var nextPages = Math.max(1, Math.ceil(nextTotal / pageSize));
        nextPage = Math.min(Math.max(1, nextPage), nextPages);
        var start = (nextPage - 1) * pageSize;
        var wanted = matching ? matching.slice(start, start + pageSize).map(function (product) { return product.id; }) : null;
        var neededPages = matching ? Array.from(new Set(wanted.map(function (id) {
          return Math.floor(index.findIndex(function (product) { return product.id === id; }) / pageSize) + 1;
        }))) : (total ? [nextPage] : []);
        var loaded = await Promise.all(neededPages.map(ensureCardPage));
        if (token !== navigation || !root.isConnected) return;
        var entries = loaded.reduce(function (all, batch) { return all.concat(batch); }, []);
        if (wanted) entries = entries.filter(function (entry) { return wanted.includes(entry.id); });
        else wanted = entries.map(function (entry) { return entry.id; });
        if (entries.length !== wanted.length || wanted.some(function (id) { return !entries.some(function (entry) { return entry.id === id; }); })) {
          throw new Error('Incomplete selected products');
        }
        connectCards(entries);
        group = nextGroup;
        page = nextPage;
        matchingTotal = nextTotal;
        render(wanted);
        clearNotice();
        var url = locationFor(group, page);
        if (scroll || historyMode === 'replace' && window.location.hash === '#' + root.id) url.hash = root.id;
        if (historyMode === 'push') window.history.pushState(null, '', url);
        else window.history.replaceState(null, '', url);
        committedUrl = url.toString();
        if (scroll) {
          root.scrollIntoView({ block: 'start', behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
          count.setAttribute('tabindex', '-1');
          count.focus({ preventScroll: true });
        }
      } catch (error) {
        if (token === navigation && root.isConnected) showError(target);
      }
    }

    // The current SSR page is immediately usable. All/page=N has no index or
    // remainder request; only explicit category/legacy-page intent loads data.
    render(initialEntries.map(function (entry) { return entry.id; }));
    buttons.forEach(function (button) {
      button.addEventListener('click', function () { choose(button.dataset.bestGroup, 1, false, 'push'); });
    });
    root.querySelectorAll('[data-best-clear-group]').forEach(function (button) {
      button.addEventListener('click', function () {
        choose('', 1, false, 'push');
        selector.querySelector('[data-best-group=""]').focus({ preventScroll: true });
      });
    });
    pagination.addEventListener('click', function (event) {
      var link = event.target.closest('[data-best-page-link]');
      if (!link || event.button || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      choose(group, Number(link.dataset.bestPageLink), true, 'push');
    });
    window.addEventListener('popstate', function () {
      if (!root.isConnected) return;
      var requested = requestedLocation();
      choose(requested.group, requested.page, false, 'replace');
    });
    selector.removeAttribute('inert');
    selector.removeAttribute('data-best-pending');
    selector.hidden = false;
    var requested = requestedLocation();
    if (requested.group || requested.page !== currentServerPage) choose(requested.group, requested.page, false, 'replace');
    else {
      window.history.replaceState(null, '', committedUrl);
      root.removeAttribute('aria-busy');
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialise, { once: true });
  else initialise();
  document.addEventListener('shopify:section:load', initialise);
}());
